<template>
  <div>
    <AuthenticationMobile v-if="isMobile" />
    <AuthenticationDesktop v-else />
  </div>
</template>

<script>
  import Background from '@/assets/Background.png';

  export default {
    name: 'Homes',

    components: {
      AuthenticationDesktop: () => import('./AuthenticationDesktop.vue'),
      AuthenticationMobile: () => import('./AuthenticationMobile.vue'),
    },

    props: ['isMobile'],

    data: () => ({ Background }),

    computed: {},

    mounted() {},

    methods: {},
  };
</script>

<style scoped>
  .background {
    background-size: cover;
    background-repeat: no-repeat;
  }
</style>
